import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";
import {DownloadIcon} from "@ui/icons/icons";
import {sx} from './sx'
import {IExportParamsContext} from "@containers/export/containers/buildData/hooks/types/exportParams";
import ClearIcon from '@mui/icons-material/Clear';

interface IProps<T> {
    exportParams: IExportParamsContext<T>,
    disabled?: boolean
}

function ToggleExportMode<T>({exportParams, disabled}: IProps<T>) {

    const {exportMode, setExportMode} = exportParams;
    const toggleExportMode = () => {
        setExportMode((prev) => !prev)
    }

    return (
        <IconButtonCustom
            sx={sx.button}
            disabled={disabled}
            onClick={toggleExportMode}
            variant={'empty'}
        >
            {exportMode ? <ClearIcon fontSize={'small'}/> : <DownloadIcon/>}
        </IconButtonCustom>
    );
};

export default ToggleExportMode;